/** Рядок послуги об'єкта з вкладки «Інше». */
export const isOtherTeamIncome = (row: unknown): boolean => {
    if (!row || typeof row !== 'object') return false;
    const record = row as Record<string, unknown>;
    return Number(record.income_is_other ?? record.incomeIsOther ?? 0) === 1;
};
